import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { INTEREST_RATE, RECAPTCHA_TOKEN } from 'constants/index'
import { QuotaState, IQuota } from 'interfaces/quota'

const initialState: QuotaState = {
  amount: '',
  quotas: [],
  fee: '0',
  term: '0',
  rate: INTEREST_RATE,
  destination: [],
}

export const fetchLog = createAsyncThunk('quota/log', async (_, thunkAPI: any) => {
    const headers = {
      Accept: 'application/json',
      Authorization: RECAPTCHA_TOKEN,
      'Content-Type': 'application/json',
    }

    const { quota } = thunkAPI.getState()

    const body = {
      amount: quota.amount,
      term: quota.term,
      fee: quota.fee,
      rate: quota.rate,
      loanDestination: quota.destination,
    }
    await fetch(
      `${process.env.REACT_APP_URL_AUTH}/simulation/logger`,
      {
        body: JSON.stringify(body),
        headers,
        method: 'POST',
        mode: 'cors',
      }
    )
  }
)

export const quotaSlice = createSlice({
  name: 'quotaState',
  initialState,
  reducers: {
    setAmount: (state, action: PayloadAction<string>) => {
      state.amount = parseInt(action.payload,10).toLocaleString('de-DE')
    },
    setQuotas: (state, action: PayloadAction<IQuota[]>) => {
      state.quotas = action.payload
    },
    setInitialQuota: (state, action: PayloadAction<string>) => {
      state.fee = action.payload
    },
    setTermState: (state, action: PayloadAction<string>) => {
      state.term = action.payload
    },
    setDestinationState: (state, action: PayloadAction<string[]>) => {
      state.destination = action.payload
    },
  },
})

export const {
  setAmount,
  setQuotas,
  setInitialQuota,
  setTermState,
  setDestinationState,
} = quotaSlice.actions

export default quotaSlice.reducer
